<template>
  <div class="container">
    <p class="paragraph">
      {{ lineOne }}
    </p>
    <p class="paragraph">
      {{ lineTwo }}
    </p>
    <div class="buttons">
      <a
        v-for="browser in browsers"
        :key="browser.name"
        class="button cta"
        :href="browser.url"
      >
        {{ browser.name }}
      </a>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { detectiOS } from '@/utils.js'

const iOS = detectiOS()

let browsers = [
  {
    name: 'Edge',
    url: 'https://www.microsoft.com/windows/microsoft-edge'
  },
  {
    name: 'Chrome',
    url: 'https://www.google.com/chrome/'
  },
  {
    name: 'Firefox',
    url: 'https://www.mozilla.org/firefox/'
  }
]
if (iOS) {
  browsers = [{
    name: 'Safari',
    url: 'https://support.apple.com/safari'
  }]
}

const shuffleArray = function (array) {
  // https://stackoverflow.com/a/2450976
  var currentIndex = array.length; var temporaryValue; var randomIndex

  // While there remain elements to shuffle...
  while (currentIndex !== 0) {
    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex)
    currentIndex -= 1

    // And swap it with the current element.
    temporaryValue = array[currentIndex]
    array[currentIndex] = array[randomIndex]
    array[randomIndex] = temporaryValue
  }

  return array
}

browsers = shuffleArray(browsers)

export default Vue.extend({
  data: function () {
    return {
      iOS,
      browsers
    }
  },
  computed: {
    lineOne: function () {
      let text = this.$t('your_browser_is_not_supported')
      if (this.iOS) {
        text = this.$t('your_version_of_ios')
      }
      return text
    },
    lineTwo: function () {
      let text = this.$t('please_use')
      if (this.iOS) {
        text = this.$t('use_a_current_version_of_ios')
      }
      return text
    }
  }
})
</script>

<style lang="scss" scoped>
.container {
  max-width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 1rem;
  .paragraph {
    max-width: 100%;
  }
  .buttons {
    display: flex;
    flex-wrap: wrap;
    margin-top: 1rem;
    .button {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 1rem;
      font-family: 'Futura Heavy';
      font-size: 1.8rem;
      font-weight: 400;
      box-shadow: 0px 3px 8px 0px rgba(42,55,71,0.15);
      background-color: #3d56f5;
      color: #ffffff;
      border-radius: 3px;
      text-decoration: none;
    }
  }
}
</style>
